export default __webpack_public_path__ + "static/media/Omron Microscan.171ce7fe.png";